export default __webpack_public_path__ + "static/media/redeem-bonus2-m-2.ec5e8b25.webp";